import './header.component.scss'

import customSelect from 'custom-select'
import './../../styles/modules/plugins/custom-select.scss'

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

class HeaderSubs {
  constructor(elements, config, classes, functions) {
    this.elements = elements

    this.config = config

    this.classes = classes

    this.scroll = functions.scroll

    this.currentElements = {
      source: null,
      drop: null
    }

    this.init()
  }

  isMobile() {
    return window.innerWidth < this.config.breakpoint
  }

  isOpened() {
    return this.currentElements.source && this.currentElements.drop
  }

  addOpenClasses() {
    this.elements.sub.openedDest.append(this.currentElements.drop)
    this.elements.sub.openedWrap.classList.add(this.classes.status.opened)
    this.elements.menu.inner.classList.add(this.classes.status.subOpened)
  }

  setCurrents(source, drop) {
    this.currentElements.source = source
    this.currentElements.drop = drop
  }

  moveToSource() {
    this.currentElements.source.append(this.currentElements.drop)
  }

  clearCurrents() {
    this.currentElements.source = null
    this.currentElements.drop = null
  }

  removeOpenClasses() {
    this.elements.sub.openedWrap.classList.remove(this.classes.status.opened)
    this.elements.menu.inner.classList.remove(this.classes.status.subOpened)
  }

  open(event) {
    if (this.isMobile()) {
      event.preventDefault()

      this.elements.sub.openedDest.scrollTo(0, 0)

      const btn = event.target
      const source = btn.closest(`.${this.classes.elements.dropItem}`)
      const drop = source.querySelector(`.${this.classes.elements.dropList}`)
      console.log(btn.textContent)

      if (drop) {
        this.setCurrents(source, drop)

        this.addOpenClasses()

        this.elements.main.header.style.setProperty('--nav-back-btn-height', `${this.elements.sub.backBtn.offsetHeight}px`)

        this.scroll.disable(this.elements.sub.openedDest)
      }
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }

    if (this.isOpened()) {
      const animateClosing = () => {
        this.elements.sub.openedWrap.classList.add(this.classes.status.closing)
        setTimeout(() => {
          this.elements.sub.openedWrap.classList.remove(this.classes.status.closing)
          this.moveToSource()
          this.clearCurrents()
        }, this.config.animationDuration)
      }

      this.removeOpenClasses()
      this.elements.main.header.style.removeProperty('--nav-back-btn-height')

      animateClosing()

      this.scroll.enable()
      this.scroll.disable(this.elements.menu.inner)
    }
  }

  forceClose() {
    if (this.isOpened()) {
      this.moveToSource()
      this.clearCurrents()
      this.removeOpenClasses()
      this.elements.main.header.style.removeProperty('--nav-back-btn-height')
    }
  }

  defineEvents() {
    this.elements.sub.openBtns.forEach(btn => {
      btn.addEventListener('click', this.open.bind(this))
    })

    this.elements.sub.backBtn.addEventListener('click', this.close.bind(this))
  }

  init() {
    this.defineEvents()
  }
}

class HeaderMenu {
  constructor(elements, config, classes) {
    this.elements = elements

    this.config = config

    this.classes = classes

    this.states = {
      opened: false
    }

    this.init()
  }

  scroll = {
    disable(el) {
      disableBodyScroll(el)
    },
    enable() {
      clearAllBodyScrollLocks()
    }
  }

  isOpened() {
    return this.states.opened
  }

  defineCssVars() {
    this.elements.main.header.style.setProperty('--nav-animation-duration', `${this.config.animationDuration}ms`)
  }

  addOpenClasses() {
    this.elements.main.header.classList.add(this.classes.status.opened)
    this.elements.menu.nav.classList.add(this.classes.status.opened)
    this.elements.menu.toggleBtn.classList.add(this.classes.status.opened)
  }

  removeOpenClasses() {
    this.elements.main.header.classList.remove(this.classes.status.opened)
    this.elements.menu.nav.classList.remove(this.classes.status.opened)
    this.elements.menu.toggleBtn.classList.remove(this.classes.status.opened)
  }

  open() {
    this.addOpenClasses()

    this.scroll.disable(this.elements.menu.inner)

    this.elements.menu.inner.scrollTo(0, 0)

    this.states.opened = true
  }

  close(isForce) {
    const animateClosing = () => {
      this.elements.menu.nav.classList.add(this.classes.status.closing)
      setTimeout(() => {
        this.elements.menu.nav.classList.remove(this.classes.status.closing)
      }, this.config.animationDuration)
    }

    this.removeOpenClasses()

    if (!isForce || (typeof (isForce) === 'object')) {
      animateClosing()
    }

    this.scroll.enable()

    this.states.opened = false

    this.subMenu.forceClose()
  }

  toggleMenu() {
    if (this.isOpened()) {
      this.close()
    } else {
      this.open()
    }
  }

  forceClose() {
    if (this.isOpened()) {
      const isForce = true

      this.close(isForce)
    }

    this.elements.main.header.classList.add(this.classes.status.transitionsOff)
    setTimeout(() => {
      this.elements.main.header.classList.remove(this.classes.status.transitionsOff)
    }, this.config.animationDuration)
  }

  defineEvents() {
    this.elements.menu.toggleBtn.addEventListener('click', this.toggleMenu.bind(this))
    this.elements.menu.overlay.addEventListener('click', this.close.bind(this))

    const media = `(min-width: ${this.config.breakpoint}px)`
    const mediaWatcher = window.matchMedia(media)
    mediaWatcher.addEventListener('change', this.forceClose.bind(this))
  }

  init() {
    this.defineCssVars()
    this.defineEvents()

    this.subMenu = new HeaderSubs(this.elements, this.config, this.classes, {
      scroll: this.scroll
    })
  }
}

class HeaderBar {
  constructor(selects) {
    this.selects = selects

    this.init()
  }

  defineEvent(el) {
    el.addEventListener('change', e => {
      window.location.assign(e.target.value)
    })
  }

  styleSelect(el) {
    customSelect(el)
    const cstSel = el.customSelect

    const hoverMedia = window.matchMedia('(hover: hover)')

    cstSel.container.addEventListener('mouseenter', () => {
      if (hoverMedia.matches) {
        cstSel.open = true
      }
    })

    cstSel.container.addEventListener('mouseleave', () => {
      if (hoverMedia.matches) {
        cstSel.open = false
      }
    })
  }

  giveAriaLabels(el) {
    const container = el.closest('.custom-select-container')
    const opener = container.querySelector('.custom-select-opener')
    const panel = container.querySelector('.custom-select-panel')

    if (opener) {
      opener.setAttribute('aria-label', 'select-opener')
    }
    if (panel) {
      panel.setAttribute('aria-label', 'select-panel')
    }
  }

  selectsIteration() {
    this.selects.forEach(select => {
      // const isAreas = select.dataset.role
      
      this.defineEvent(select)
      this.styleSelect(select)
      this.giveAriaLabels(select)
    })
  }

  init() {
    this.selectsIteration()
  }
}

class Header {
  constructor(elements, config, classes) {
    this.elements = elements

    this.config = config

    this.classes = classes

    this.init()
  }

  stickyToggle() {
    const height = this.elements.main.header.offsetHeight
    const isHeight = window.pageYOffset > height

    if (isHeight) {
      this.elements.main.header.classList.add(this.classes.status.sticky)
    } else {
      this.elements.main.header.classList.remove(this.classes.status.sticky)
    }
  }

  defineStickyEvent() {
    this.stickyToggle()
    window.addEventListener('scroll', this.stickyToggle.bind(this))
  }

  defineEvents() {
    this.defineStickyEvent()
  }

  defineMenu() {
    new HeaderMenu(this.elements, this.config, this.classes)
  }

  defineBar() {
    new HeaderBar(this.elements.bar.selects)
  }

  init() {
    this.defineEvents()
    this.defineMenu()
    this.defineBar()
  }
}

const headerEl = document.querySelector('.header')

if (headerEl) {
  const navEl = headerEl.querySelector('.nav')

  new Header({
    main: {
      header: headerEl
    },
    menu: {
      toggleBtn: headerEl.querySelector('.header__toggle'),
      overlay: headerEl.querySelector('.header__nav-overlay'),
      inner: navEl.querySelector('.nav__list'),
      nav: navEl,
    },
    sub: {
      openBtns: navEl.querySelectorAll('.nav__link_with-list'),
      openedWrap: navEl.querySelector('.nav__dropdown-opener'),
      openedDest: navEl.querySelector('.nav__dropdown-destination'),
      backBtn: navEl.querySelector('.nav__dropdown-back')
    },
    bar: {
      selects: headerEl.querySelectorAll('.header-bar__select select')
    }
  }, {
    breakpoint: 1280,
    animationDuration: 500
  }, {
    elements: {
      dropItem: 'nav__item_with-list',
      dropList: 'nav__sub-list'
    },
    status: {
      sticky: 'sticky',
      opened: 'opened',
      subOpened: 'sub-opened',
      closing: 'closing',
      transitionsOff: 'transitions-off'
    }
  })
}